/* eslint-disable */
import { useDisclosure } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllUserPosts } from "../../redux/peoplePost/peoplepost.actions";
import DashboardLayout from "../DashboardHome/DashboardLayout";
import { setIsLoading } from "../../redux/features/features.action";
import { searchEvents } from "../../redux/api";
import {
  logOut,
  setModalStatus,
  setStatus,
} from "../../redux/auth/auth.actions";
import dayjs from "dayjs";
import RelativeTime from "dayjs/plugin/relativeTime";
import TitleHeader from "./TitleHeader";
import CreateCommunity from "./CreateCommunity";
import JoinCommunityModal from "./JoinCommunityModal";

import { useNavigate, useParams } from "react-router-dom";
import { getGoogleLocation } from "../../utils/utils";

import Feeds from "./Feeds";
import Communities from "./Communities";

function Community() {
  const { onOpen, onClose } = useDisclosure();
  const darktheme = useSelector((state) => state.features.settings.darktheme);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.accessToken);
  const { user } = useSelector((state) => state.auth);
  const [search] = useState("");
  const [, setLoading] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const uploadModalStatus = useSelector((state) => state.auth.showUploadModal);
  const [selectedCommunityId, setSelectedCommunityId] = useState("");
  const [event, setEvents] = useState([]);
  const [feeds, setFeeds] = useState(null);
  const { id } = useParams();
  const [currentLocation, setCurrentLocation] = useState({
    longitude: null,
    latitude: null,
  });

  const navigate = useNavigate();
  useEffect(() => {
    if (!token) {
      navigate("/dashboard/home");
    }
  }, []);

  dayjs.extend(RelativeTime);

  useEffect(() => {
    dispatch(getAllUserPosts());
    dispatch(setIsLoading(true));
  }, [token]);

  const handleSearch = async (more = false) => {
    setLoading(false);
    try {
      !more && setLoading(true);
      const { data } = await searchEvents({ page, search });
      if (data) {
        const documents = data?.hits?.map((item) => {
          return {
            ...item.document,
            media: {
              images: item.document["media.images"],
              videos: item.document["media.videos"],
            },
          };
        });
        setEvents(page === 1 ? documents : [...event, ...documents]);
        setTotalPages(Math.ceil(data.found / data.request_params.per_page));
        setLoading(false);
        setLoadingMore(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user.isDeleted) {
      dispatch(setStatus(true));
      dispatch(logOut());
    }
  }, [user]);

  const handleModalCreateCommunity = () => {
    onOpen();
    dispatch(setModalStatus(71));
  };

  const CloseCommunityModal = () => {
    onClose();
    dispatch(setModalStatus(0));
  };

  const memberJoinCommunity = async (code, id) => {
    setSelectedCommunityId(id);
    onOpen();
    dispatch(setModalStatus(72));
    await submit(code);
  };

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const { lat, lng } = await getGoogleLocation();
        setCurrentLocation({
          latitude: lat,
          longitude: lng,
        });
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };

    fetchLocation();
    // eslint-disable-next-line
  }, []);

  const viewTab = (id) => {
    navigate(`/dashboard/community/${id}`);
  };

  return (
    <DashboardLayout>
      <TitleHeader theme={darktheme} click={handleModalCreateCommunity} />
      <div className={` h-[100vh] ${darktheme ? "bg-kdark3 " : "bg-white "}`}>
        <div
          className={`w-full h-auto  ${darktheme ? "bg-kdark3" : "bg-[#fff]"}`}
        >
          <div className=" w-[95%] lg:w-[80%] lg:max-w-[600px] mx-auto ">
            <div className="flex w-full mb-[2rem]">
              <p
                className={`${
                  darktheme ? "text-white" : "text-[#27272e]"
                } cursor-pointer p-1 w-[50%] text-center font-[590] text-[14px]  ${
                  id === "feeds" && "bord-gr "
                } pb-1  md:pb-[.8rem]  `}
                onClick={() => viewTab("feeds")}
              >
                My Feeds
              </p>
              <p
                onClick={() => viewTab("communities")}
                className={`${
                  darktheme ? "text-white" : "text-[#27272e]"
                } w-[50%] cursor-pointer text-center font-[590] text-[14px] text-[#27272e] ${
                  id === "communities" && "bord-gr "
                }  `}
              >
                My Communities
              </p>
            </div>

            {id === "feeds" && (
              <Feeds
                isLoading={isLoading}
                handleSearch={handleSearch}
                feeds={feeds}
                memberJoinCommunity={memberJoinCommunity}
                currentLocation={currentLocation}
                darktheme={darktheme}
              />
            )}
            {id === "communities" && <Communities darktheme={darktheme} />}
          </div>
        </div>
      </div>
      {uploadModalStatus === 71 && (
        <CreateCommunity
          open={uploadModalStatus === 71}
          type={"My"}
          onClose={CloseCommunityModal}
        />
      )}
      {uploadModalStatus === 72 && (
        <JoinCommunityModal
          id={selectedCommunityId}
          open={uploadModalStatus === 72}
          type={"My"}
          onClose={CloseCommunityModal}
        />
      )}
    </DashboardLayout>
  );
}

export default Community;
